export { default } from './HeaderIconLogoContainer';
